import { axiosInstance } from "../../axios-Instance";
import { getLoginToken } from "../../storage";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "../../react-query/constants";

async function getKey() {
  const data = await axiosInstance({
    url: "/key",
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });

  return data?.data?.data;
}

const createKey = async (formData: any) => {
  const data = await axiosInstance({
    url: "/key",
    method: "POST",
    data: formData,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};

const updateKey = async (formData: any) => {
  const data = await axiosInstance({
    url: `/key/${formData["_id"]}`,
    method: "PUT",
    data: formData,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};

const deleteKey = async (formData: any) => {
  const data = await axiosInstance({
    url: `/key/${formData}`,
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};

export function useKey() {
  const fallback: any = [];
  const { data = fallback } = useQuery({
    queryKey: [queryKeys.key],
    queryFn: () => getKey(),
  });
  return data;
}

export function useCreateKey() {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset, isError, error } = useMutation({
    mutationFn: (formData) => createKey(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.key]);
    },
  });
  return { mutate, isSuccess, reset, isError, error };
}

export function useUpdateKey() {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset, isError, error } = useMutation({
    mutationFn: (formData) => updateKey(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.key]);
    },
  });
  return { mutate, isSuccess, reset, isError, error };
}

export function useDeleteKey() {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset, isError, error } = useMutation({
    mutationFn: (formData) => deleteKey(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.key]);
    },
  });
  return { mutate, isSuccess, reset, isError, error };
}
